import * as yup from 'yup';

export const schema = yup
  .object({
    busca_produto: yup.object({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    busca_parceiro: yup.object({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    cod_tipo_ajuste: yup.object({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    qtd_ajuste: yup.string().required(),
    des_un: yup.object({
      label: yup.string().required(),
      value: yup.string().required(),
    }),
    des_emb: yup.string().required(),
    val_custo_unit: yup.string().required(),
    num_docto: yup.string().nullable(true).notRequired(),
  })
  .required();
